import * as React from 'react';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import { i18n, DateFormatter } from 'arm-common';
import { AppConstants } from '../../constants/AppConstants';
import DocumentiActions from './DocumentiActions';

class DocumentiDetails extends React.Component{

    constructor(props){
        super(props);

        this.componentName = "[DocumentiDetails.jsx]";
        this.detailsOnClick = this.detailsOnClick.bind(this);
        this.openDocVersion = this.openDocVersion.bind(this);
    }

    componentDidMount(){
        console.log(this.componentName + "componentDidMount");

        let columns = [
            { field: 'id', title: 'ID', sortable: 'true' },
            { field: 'nomeVersione', title: i18n('ARM.CORE.PRINT.VERSION','Versione'), sortable: 'false' },
            { field: 'dataInizio', title: i18n('ARM.CORE.PRINT.DATA.INIZIO','Data Inizio Validità'), sortable: 'true', formatter: this.dateFormatterShort },
            { field: 'dataFine', title: i18n('ARM.CORE.PRINT.DATA.FINE','Data Fine Validità'), sortable: 'true', formatter: this.dateFormatterShort },
            { field: 'idUserUpdate', title: i18n('ARM.CORE.PRINT.MODIFICATO','Modificato da'), sortable: 'true' },
            { field: 'info', title: i18n('ARM_CORE_PRINT.SHARED.DETTAGLI', 'Dettagli'), formatter: this.columnDetail }
        ];

        $(this.refs.VersioniDocumentoTable).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.detailsOnClick(row, $element, field),
            //sortOrder: "desc",
            pagination: true,
        });

        if(this.props.idDocumentoOrigine){
            this.props.getVersioniDocumento(this.props.idDocumentoOrigine);
        }
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');
        if (nextProps.versioniDoc !== this.props.versioniDoc) {

            if(nextProps.versioniDoc.length === 0){
                this.openDocVersion(this.props.idDocumentoOrigine);
            }

            console.log("\t rows: " + (nextProps.versioniDoc !== null ? nextProps.versioniDoc.length : "NULL"));
            $(this.refs.VersioniDocumentoTable).bootstrapTable('load', nextProps.versioniDoc);
        }

        if(nextProps.versioniDoc){
            if(nextProps.versioniDoc.length > 0){
                let idUltimaVersioneDoc = Math.max(...nextProps.versioniDoc.map(x => x.id));
                this.props.updateIdUltimaVersioneDocumento(idUltimaVersioneDoc);
            }
            else if(nextProps.versioniDoc.length === 0){
                this.props.updateIdUltimaVersioneDocumento(this.props.idDocumentoOrigine);
            }
        }
        
    }

    render() {
        console.log(this.componentName + 'render');
        const { } = this.props;
        return (
            <div className="mt-3">
                <agui.aCard>
                    <agui.aCardBody>
                        <table ref="VersioniDocumentoTable" className={AppConstants.CLASS_BOOSTRAP_TABLE} />
                    </agui.aCardBody>
                    <agui.aCardFooter>
                        <agui.LineBar>
                            <agui.LineBarGroup right={true}>
                                <agui.aButton bs='secondary'
                                //  onClick={() => this.props.history.goBack()}
                                onClick={()=>this.props.history.push(`/documenti`, {from: 'documentiDetails'})}
                                 >
                                    {
                                        i18n('ARM_CORE_PRINT.SHARED.INDIETRO', 'Indietro')
                                    }
                                </agui.aButton>
                            </agui.LineBarGroup>
                        </agui.LineBar>
                    </agui.aCardFooter>
                </agui.aCard>                
            </div>
        );
    }    
    
     detailsOnClick(row, $element, field) {
         console.log(this.componentName + " deatilsOnClick: " + row.id);
         if (field === "info") {
            this.openDocVersion(row.id);
         }
     }


    openDocVersion(id){
        this.props.setIsAlreadyExistingDoc(true);
        this.props.getDocumentById(id);
        this.props.history.push({ pathname: '/nuovoDoc' });
     }


    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    dateFormatterShort(value, row, index) {
        return DateFormatter.dataFormatterShort(value);
    }

    columnDetail(value, row, index) {
        console.log(this.componentName + " columnDetail: " + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm' href='#/nuovoDoc'><i class='fas fa-info fa-fw' data-toggle='tooltip' data-placement='top' title='Visualizza'/></button>";
        return temp;
    }

};


function mapDispatchToProps(dispatch) {
    return {
        getVersioniDocumento(idDocumento){
            return dispatch(DocumentiActions.getVersioniDocumento(idDocumento))
        },
        setIsAlreadyExistingDoc(isAlreadyExistingDoc) {
            return dispatch(DocumentiActions.setIsAlreadyExistingDoc(isAlreadyExistingDoc));
        },
        getDocumentById(docId) {
            return dispatch(DocumentiActions.getDocumentById(docId));
        },
        updateIdUltimaVersioneDocumento(newVersionId){
            return dispatch(DocumentiActions.updateIdUltimaVersioneDocumento(newVersionId));
        }
    }
};

function mapStateToProps(state) {
    return {
        versioniDoc: state.documentiReducer.versioniDoc,
        documento: state.documentiReducer.documento,
        idDocumentoOrigine : state.documentiReducer.idDocumentoOrigine
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(DocumentiDetails);